import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['iframe'];
    static values = {
        videoId: String,
        autoplay: String
    };

    connect() {
        this.observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                this.loadIframe();
                this.observer.disconnect();
            }
        }, {
            threshold: 0.1
        });

        this.observer.observe(this.element);
    }

    loadIframe() {
        const iframe = this.iframeTarget;
        const src = `https://www.youtube.com/embed/${this.videoIdValue}?autoplay=${this.autoplayValue}`;
        iframe.src = src;
    }

    disconnect() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
